import React, { useContext } from 'react';
import { Tab } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';

import {
	getCourseMindItemsLoadingState as getCourseMindItemsLoadingStateSelector,
	getPaginationSelector,
	getSearchResults as getSearchResultsSelector,
	SearchLoadingStatus,
} from '../../../../reducers/search.selectors';
import { trackingEvents } from '../../../../services/tracking/trackConfig';
import { MasterLayoutContext } from '../../../../state/MasterLayoutProvider';
import { SearchResultsTab } from '../../../../types/search';
import { hasNext } from '../../../../utils/pagination';
import CourseMuiCard from '../../../cards/MuiCard/CourseMuiCard/CourseMuiCard';
import { getCourseMuiCardProps } from '../../../cards/MuiCard/CourseMuiCard/utils';
import WithTracking from '../../../utils/WithTracking';
import EmptySearchResultsNewUI from '../EmptySearchResultsNewUI';
import SearchResultsContainer from '../SearchResultsContainer';
import SearchResultsLoader from '../SearchResultsLoader';
import SearchResultsTopbarNewUI from '../SearchResultsTopbar';
import SingleSearchResultContainer from '../SingleSearchResultContainer';
import type { SearchResultsTabProps } from './SearchResultsTab';

const CourseMindItemsTab = ({
	searchTerm,
	requestFilters,
	loadMore,
	searchEngineVersion,
	onShowNotification,
}: SearchResultsTabProps) => {
	const courseMindItems = useSelector((state) => getSearchResultsSelector(state, 'courseMindItems'));
	const courseMindItemsPagination = useSelector(getPaginationSelector('courseMindItems'));
	const courseMindItemsLoadingState = useSelector(getCourseMindItemsLoadingStateSelector);
	const { mainContentContainer } = useContext(MasterLayoutContext);

	return (
		<Tab.Pane eventKey={SearchResultsTab.COURSES} data-testid="new-ui-course-tab">
			<SearchResultsTopbarNewUI
				total={courseMindItemsPagination.total}
				searchTerm={searchTerm}
				isLoaded={courseMindItemsLoadingState === SearchLoadingStatus.LOADED}
				requestFilters={requestFilters}
				withSortByFilter={false}
			/>
			{courseMindItemsLoadingState === SearchLoadingStatus.INITIAL ||
			courseMindItemsLoadingState === SearchLoadingStatus.NONE ? (
				<SearchResultsLoader />
			) : (
				<>
					{courseMindItems.length > 0 ? (
						<InfiniteScroll
							loadMore={loadMore}
							hasMore={
								hasNext(courseMindItemsPagination) &&
								courseMindItemsLoadingState !== SearchLoadingStatus.PAGINATION
							}
							className="search-results__infinite-scroll-box"
							useWindow={false}
							getScrollParent={() => mainContentContainer}
						>
							<SearchResultsContainer>
								{courseMindItems.map((courseMindItem, index) => (
									<SingleSearchResultContainer key={courseMindItem.id}>
										<WithTracking
											events={{
												onClick: trackingEvents.itemOpen,
												onMiddleClick: trackingEvents.itemOpen,
												onContextMenu: trackingEvents.itemOpen,
											}}
											eventPayload={{
												other: {
													minditem_id: courseMindItem.id,
													index,
													searchEngineVersion,
												},
											}}
										>
											<div>
												<CourseMuiCard
													{...getCourseMuiCardProps(courseMindItem)}
													index={index}
													onShowNotification={onShowNotification}
												/>
											</div>
										</WithTracking>
									</SingleSearchResultContainer>
								))}
							</SearchResultsContainer>
						</InfiniteScroll>
					) : (
						<SearchResultsContainer>
							<EmptySearchResultsNewUI searchTerm={searchTerm} />
						</SearchResultsContainer>
					)}
					{courseMindItemsLoadingState === SearchLoadingStatus.PAGINATION && <SearchResultsLoader />}
				</>
			)}
		</Tab.Pane>
	);
};

export default CourseMindItemsTab;
